import { render, staticRenderFns } from "./QualificationsAdminMobileCard.vue?vue&type=template&id=00aed520&scoped=true"
import script from "./QualificationsAdminMobileCard.vue?vue&type=script&lang=js"
export * from "./QualificationsAdminMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aed520",
  null
  
)

export default component.exports